import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center pa-4 text-center ga-4 flex-wrap"
}
const _hoisted_2 = { class: "p-text-md ellipsis" }
const _hoisted_3 = {
  key: 0,
  class: "position-absolute badge"
}
const _hoisted_4 = { class: "d-flex ga-2" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2 unread"
}
const _hoisted_6 = {
  class: "font-size-10-400 font-grey-dark",
  style: {"margin-top":"2px"}
}
const _hoisted_7 = {
  key: 3,
  class: "text-center"
}

import {computed, reactive, ref, shallowRef, watch} from 'vue';
import {filesService} from '@/api/services/file';
import {useSettingsStore} from '@/api/store/settings';
import {sortValues} from "@/views/OrdersComponents/Helpers";
import ButtonFilterSelect from "@/components/custom/ButtonFilterSelect/ButtonFilterSelect.vue";
import SearchFilter from "@/components/custom/SearchFilter.vue";
import debounce from 'lodash/debounce';
import moment from "moment/moment";
import {useRouter} from "vue-router";
import ButtonFixed from "@/components/custom/ButtonFixed.vue";
import RoundButton from "@/components/custom/RoundButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentDocuments',
  setup(__props) {

_useCssVars(_ctx => ({
  "v4fd94b42": (_unref(setAppColor))
}))

const settingsStore = useSettingsStore();
const router = useRouter();

const loading = ref(false);

const setAppColor = settingsStore.settings.buttonColor2

const filters = [
  {
    name: 'Filter',
    label: 'All'
  },
  {
    name: 'created_at',
    label: 'Date'
  },
  {
    name: 'id',
    label: 'Id'
  },
]

// Data
const state = reactive({
  items: [] as any[],
  pagination: {
    meta: {},
    links: [],
    next_page_url: null,
  },
  search: '' as string,
  filterSelected: 'filter' as string,
  selectFolderTag: 'all' as number|string,
  folderTags: [] as any[],
});

const sortTabSelectedValue = shallowRef({
  name: 'Sort',
  label: 'Sort'
})
const filterTabSelectedValue = shallowRef({
  name: 'Filter',
  label: 'Filter'
})
const page = shallowRef(1)

// Computed
const isFilterTabSelected = computed(() => {
  return state.filterSelected === 'filter'
});

const isSortTabSelected = computed(() => {
  return state.filterSelected === 'sort'
});

const filterQueryString = computed(() => {
  let filter = {
    sorting: '',
    search: state.search,
    page: page.value,
    kind: 'documents',
    tag: state.selectFolderTag
  };

  let sortOrder = sortTabSelectedValue.value.name === 'Sort' ? 'desc' : sortTabSelectedValue.value.name;

  let filterValue = filterTabSelectedValue.value.name === 'Filter' ? 'title' : filterTabSelectedValue.value.name;

  if (filterTabSelectedValue.value.name === 'Filter' && sortTabSelectedValue.value.name === 'Sort') {
    filter.sorting = 'id,desc';
  } else {
    filter.sorting = `${filterValue},${sortOrder}`;
  }

  return filter;
});

const getFiles = () => {
  loading.value = true;

  filesService.index(filterQueryString.value).then((response) => {
    state.items.push(...response.data)
    state.pagination.meta = response.meta;
    state.pagination.links = response.links;
    state.pagination.next_page_url = response.links.next;
  }).finally(() => {
    loading.value = false;
  });

  filesService.getFolderTags({ skipGlobalLoading: true }).then((response) => {
    state.folderTags = response.data;
  });
}

// Debounced to fetch getMedicalAlerts
const debouncedGetOrders = debounce(getFiles, 300);

const resetState = () => {
  page.value = 1;
  state.items = [];
  loading.value = true;
}

const seeMore = () => {
  if (state.pagination.next_page_url) {
    page.value++;
    getFiles();
  }
}

const openFile = (file: any) => {

  if (file.file_resource?.kind == 'plan') {
    router.push({name: 'document-viewer', params: {id: file.file_resource.model_id}});
  } else {
    // Handle file through browser window - may require FileSystem integration
    window.open(file.file_resource?.file.file_path, '_blank');
  }

  if (file.viewed_by_client == 0) {
    filesService.viewedByClient(file.client_id, file.file_resource_id).then(() => {
      state.items = state.items.map((item) => {
        if (item.id == file.id) {
          item.viewed_by_client = 1;
        }
        return item;
      })
    })
  }

}

watch(() => [filterTabSelectedValue.value, sortTabSelectedValue.value, state.search, state.selectFolderTag], () => {
  resetState();
  debouncedGetOrders();
});

getFiles();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0 pt-0 mb-12 position-relative",
    style: {"background-color":"#F0F0F0","min-height":"100vh"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "mt-0 mb-2 py-5 text-center",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "text-left pl-2",
            cols: "12"
          }, {
            default: _withCtx(() => [
              (state.folderTags.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_sheet, {
                      style: _normalizeStyle({ 
              background: 'white', 
              boxShadow: '4px 4px 10px 0px #0000000D', 
              color: _unref(settingsStore).settings.primaryColor,
              border: state.selectFolderTag === 'all' ? `1px solid ${_unref(settingsStore).settings.primaryColor}` : ''
            }),
                      class: _normalizeClass(["px-1 py-3 b-round-20 position-relative text-center", { 'border-class': state.selectFolderTag === 'all'}]),
                      width: "100",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (state.selectFolderTag = 'all'))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "my-2",
                          icon: "mdi mdi-file-document-outline",
                          size: "40"
                        }),
                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "p-text-md" }, "All files", -1))
                      ]),
                      _: 1
                    }, 8, ["style", "class"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.folderTags, (folder, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `folder-${index}`
                      }, [
                        (folder.visible_to_clinic)
                          ? (_openBlock(), _createBlock(_component_v_sheet, {
                              key: 0,
                              style: _normalizeStyle({ 
                background: 'white', 
                boxShadow: '4px 4px 10px 0px #0000000D', 
                color: folder?.color,
                border: state.selectFolderTag === folder.id ? `1px solid ${_unref(settingsStore).settings.primaryColor}` : ''
              }),
                              class: "px-1 py-3 b-round-20 position-relative text-center",
                              width: "100",
                              onClick: ($event: any) => (state.selectFolderTag = folder.id)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  class: "my-2",
                                  icon: "mdi mdi-file-document-outline",
                                  size: "40"
                                }),
                                _createElementVNode("p", _hoisted_2, _toDisplayString(folder.name), 1),
                                (folder?.unviewed_count)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(folder?.unviewed_count), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["style", "onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "text-left pl-2",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "font-size-18-600" }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" Recent Documents ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(SearchFilter, {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = (val) => state.search = val)
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "d-flex px-3",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "mt-1 position-relative left-filter-text",
                onClick: _cache[3] || (_cache[3] = ()=>state.filterSelected = 'sort')
              }, {
                default: _withCtx(() => [
                  _createVNode(ButtonFilterSelect, {
                    modelValue: sortTabSelectedValue.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((sortTabSelectedValue).value = $event)),
                    "is-tab-selected": isSortTabSelected.value,
                    items: _unref(sortValues),
                    multiple: false,
                    text: sortTabSelectedValue.value,
                    icon: "sort-icon",
                    "single-line": ""
                  }, null, 8, ["modelValue", "is-tab-selected", "items", "text"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "mt-1 position-relative left-filter-text",
                onClick: _cache[5] || (_cache[5] = ()=> state.filterSelected = 'filter')
              }, {
                default: _withCtx(() => [
                  _createVNode(ButtonFilterSelect, {
                    modelValue: filterTabSelectedValue.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filterTabSelectedValue).value = $event)),
                    "is-tab-selected": isFilterTabSelected.value,
                    items: filters,
                    multiple: false,
                    text: filterTabSelectedValue.value,
                    "single-line": ""
                  }, null, 8, ["modelValue", "is-tab-selected", "text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (loading.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (n) => {
            return _createElementVNode("section", {
              key: n,
              class: "mt-4 mx-4 mb-3"
            }, [
              _createVNode(_component_v_card, { class: "mt-2 mx-2 mb-2 pa-4 border-rounded" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    class: "my-0 align-center",
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "8",
                        class: "px-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_skeleton_loader, {
                            type: "text",
                            width: "80%",
                            class: "mb-2"
                          }),
                          _createVNode(_component_v_skeleton_loader, {
                            type: "text",
                            width: "40%"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        class: "text-end px-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_skeleton_loader, {
                            type: "button",
                            width: "90"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          }), 64))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(state.items, (document) => {
            return (_openBlock(), _createElementBlock("section", {
              key: document.id,
              class: "mt-4 mx-4 mb-3"
            }, [
              (document.file_resource)
                ? (_openBlock(), _createBlock(_component_v_card, {
                    key: 0,
                    class: "mt-2 mx-2 mb-2 pa-4 border-rounded"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "my-0",
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "align-center" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "px-3" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_4, [
                                        (document.viewed_by_client == 0)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_5))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("p", {
                                            class: _normalizeClass({'font-size-16-600':	document.viewed_by_client == 0, 'font-size-14-400': 	document.viewed_by_client == 1})
                                          }, _toDisplayString(document.file_resource.title), 3),
                                          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(moment)(document.created_at).format('DD MMM YYYY')), 1),
                                          (document.file_resource.tag)
                                            ? (_openBlock(), _createElementBlock("p", {
                                                key: 0,
                                                class: "font-size-10-400 mt-2 folder-tag",
                                                style: _normalizeStyle({
                        backgroundColor: document.file_resource.tag?.color
                      })
                                              }, _toDisplayString(document.file_resource.tag?.name), 5))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, { class: "text-end px-3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        class: "text-white b-round-20 outline-btn white-btn",
                                        elevation: "0",
                                        height: "32px",
                                        "x-small": "",
                                        onClick: ($event: any) => (openFile(document))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(document?.file_resource?.kind == 'plan' ? 'View' : 'Download'), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
      (!loading.value && state.items.length == 0)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 2,
            class: "mt-4 mx-4 mb-3",
            height: "50vh"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "my-2 py-1",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    class: "my-1 px-10 text-center",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_alert, {
                        type: "info",
                        variant: "tonal"
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("No Documents Available", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (state.pagination.next_page_url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_v_btn, {
              ripple: false,
              class: "load-more text-capitalize font-size-12-600",
              variant: "plain",
              onClick: seeMore
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode(" Load More ", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(ButtonFixed, {
        "color-icon": "primaryButtonColor",
        "custom-class": "text-white primary-button",
        "custom-icon-class": "add-new-circle-icon",
        icon: "add-plus-circle",
        text: "Upload Document",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(router).push({ name: 'document-upload' })))
      })
    ]),
    _: 1
  }))
}
}

})